export const game = {
  id: 'game',
  viewBox: '0 0 512 512',
  svgBody: (
    <g>
      <path
        d='M45,239.99h149.99c24.81,0,45-20.19,45-45V45c0-24.81-20.19-45-45-45H45c-24.81,0-45,20.19-45,45v149.99
            C0,219.8,20.19,239.99,45,239.99z M30,45c0-8.27,6.73-15,15-15h149.99c8.27,0,15,6.73,15,15v149.99c0,8.27-6.73,15-15,15H45
            c-8.27,0-15-6.73-15-15V45z'
      />
      <path
        d='M392.75,223.09c-17.58-17.58-46.05-17.59-63.63,0L223.06,329.14c-17.54,17.54-17.54,46.09,0,63.63l106.06,106.06
            c17.54,17.54,46.09,17.54,63.63,0l106.06-106.06c17.58-17.58,17.59-46.05,0-63.63L392.75,223.09z M477.6,371.57L371.54,477.62
            c-5.85,5.85-15.36,5.85-21.21,0L244.27,371.57c-5.85-5.85-5.85-15.36,0-21.21L350.33,244.3c5.86-5.86,15.35-5.86,21.21,0
            L477.6,350.36C483.46,356.22,483.46,365.7,477.6,371.57L477.6,371.57z'
      />
      <circle cx='164.99' cy='75' r='15' />
      <circle cx='360.97' cy='360.98' r='15' />
      <circle cx='360.97' cy='300.98' r='15' />
      <circle cx='360.97' cy='420.97' r='15' />
      <circle cx='119.99' cy='120' r='15' />
      <circle cx='74.99' cy='164.99' r='15' />
      <path
        d='M330.97,106c41.35,0,74.99,33.64,74.99,74.99c0,8.28,6.72,15,15,15s15-6.72,15-15C435.96,123.1,388.86,76,330.97,76
            c-8.28,0-15,6.72-15,15S322.69,106,330.97,106z'
      />
    </g>
  ),
}
